import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import ClientFeedbackServices from "services/ClientFeedbackServices";
import { notifyError, notifySuccess } from "utils/toast";

const ClientOnTourFeedback = ({
  isOpen,
  onClose,
  title = "Update Feedback",
  handleSubmit,
  data,
  customClass = "",
  hideAdd,
  hideEdit,
  hideView,
}) => {
  const [newFeedback, setNewFeedback] = useState("");
  const [error, setError] = useState("");
  const [feedbackHistory, setFeedbackHistory] = useState([]); 

  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const employeeName = adminInfo?.firstname || "Unknown Employee";
  const employeeId = adminInfo?.id;
  const employeeProfile = adminInfo?.profile;

  useEffect(() => {
    if (data && isOpen) {
      loadHistory();
      setNewFeedback("");
    }
  }, [data, isOpen]);

  const loadHistory = async () => {
    try {
      const res = await ClientFeedbackServices.getClientOnTourFeedback(
        data.client_id
      );
      // console.log("history ---", res);

      setFeedbackHistory(res?.feedback_history || []);
    } catch (err) {
      console.error("Error loading history:", err);
    }
  };

  const handleUpdateFeedback = async () => {
    if (!newFeedback.trim()) {
      setError("Feedback cannot be empty.");
      return;
    }

    const payload = {
      client_id: data.client_id,
      feedback: newFeedback,
      employee_name: employeeName,
      employee_profile: employeeProfile,
    };

    try {
      const res = await ClientFeedbackServices.clientfeedbackOnTourList(
        employeeId,
        payload
      );

      if (res.status) {
        notifySuccess(res.message);
        loadHistory();
        onClose();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFeedbackChange = (e) => {
    setNewFeedback(e.target.value);
  };

  const getDynamicColor = (name) => {
    let hash = 0;
    for (let i = 0; i < name?.length; i++) {
      hash = name.charCodeAt(i) + (hash << 5) - hash;
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 70%, 40%)`;
  };

  return (
    <>
      {hideView && (
        <Modal
          isOpen={isOpen}
          onClose={() => {
            onClose();
            setError("");
          }}
          className={`relative bg-white dark:bg-gray-700 pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
          aria-labelledby="modal-title"
        >
          <span id="modal-title" className="flex text-xl mb-5 text-green-500">
            {title}
          </span>

          {feedbackHistory?.length > 0 && (
            <div
    className="border border-gray-300 rounded-md p-3 bg-gray-50 
    max-h-64 overflow-y-auto space-y-3 shadow-inner"
    style={{
                  maxHeight: "30vh",
                  minHeight: "150px",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
  >
              {feedbackHistory.map((item, i) => (
                <div key={i}>
                  <p>
                    <span
                      className="text-sm font-medium"
                      style={{ color: getDynamicColor(item?.employee_name) }}
                    >
                      {item?.employee_name +
                        " (" +
                        item?.employee_profile +
                        ")"}
                    </span>
                    {" : "}
                    <span
                      className="text-sm font-medium"
                      style={{ color: getDynamicColor(item?.employee_name) }}
                    >
                      {item?.feedback}
                    </span>
                    {" "}
                    <span className="text-xs text-gray-500 ml-1">
              {item.updated_at}
            </span>
                  </p>
                </div>
              ))}
            </div>
          )}

          {hideEdit && (
            <ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
              <textarea
                onChange={handleFeedbackChange}
                placeholder="Enter Feedback"
                // style={{
                //   maxHeight: "30vh",
                //   minHeight: "150px",
                //   overflowY: "scroll",
                //   scrollbarWidth: "thin",
                // }}
                className="input w-full h-24 border border-gray-300 dark:border-gray-600 dark:bg-transparent dark:text-gray-900 rounded-md p-2"
              />

              {error && (
                <p className="error-message text-red-500 mt-2">{error}</p>
              )}

              <div className="modal-actions flex justify-around space-x-4 mt-4">
                <button
                  onClick={handleUpdateFeedback}
                  className="px-4 py-2 bg-green-500 text-white rounded-md"
                >
                  Update
                </button>

                <button
                  onClick={onClose}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
                >
                  Cancel
                </button>
              </div>
            </ModalBody>
          )}
        </Modal>
      )}
    </>
  );
};

export default ClientOnTourFeedback;
